import { render, staticRenderFns } from "./noPower.vue?vue&type=template&id=727920a2&scoped=true&"
import script from "./noPower.vue?vue&type=script&lang=js&"
export * from "./noPower.vue?vue&type=script&lang=js&"
import style0 from "./noPower.vue?vue&type=style&index=0&id=727920a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727920a2",
  null
  
)

export default component.exports